export default __webpack_public_path__ + "static/balloon-screens-ece4a22b0e43b61fd12cd145b1564251.png";